import { TableCellProps } from '../types';

type CreateActionsColumnParams<T> = {
  width?: number;
  renderActions: (rowData: T) => React.ReactNode;
};

export const ACTIONS_COLUMN_ID = '__actions';

export const createActionsColumn = <T,>({
  width = 50,
  renderActions,
}: CreateActionsColumnParams<T>): TableCellProps<T> => {
  return {
    width,
    minWidth: width,
    maxWidth: width,
    sortable: false,
    resizable: false,
    uniqueFieldId: ACTIONS_COLUMN_ID,
    headerName: '',
    fieldRender: renderActions,
  };
};
